import PeopleIcon from '@mui/icons-material/PeopleOutlined';
import PersonSearchIcon from '@mui/icons-material/PersonSearchOutlined';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswerOutlined';
import TerminalOutlinedIcon from '@mui/icons-material/TerminalOutlined';
import { InterviewTypes } from '@/utils/interviews';
import * as Styles from './InterviewType.styles';

type InterviewTypeProps = {
  type: InterviewTypes;
  onChoose: (type: InterviewTypes) => void;
};

const interviewTypesInfo = {
  [InterviewTypes.PRE_SCREENING]: {
    icon: PersonSearchIcon,
    title: 'Pre-Screening/Assessment',
  },
  [InterviewTypes.SCREENING]: {
    icon: QuestionAnswerIcon,
    title: 'Screening',
  },
  [InterviewTypes.TECHNICAL_CHALLENGE]: {
    icon: TerminalOutlinedIcon,
    title: 'Technical Challenge',
  },
  [InterviewTypes.TEAM_INTERVIEW]: {
    icon: PeopleIcon,
    title: 'Team Interview',
  },
};

const DEFAULT_INTERVIEW_TYPE_INFO = interviewTypesInfo[InterviewTypes.PRE_SCREENING];

export default function InterviewType({ type, onChoose }: InterviewTypeProps): JSX.Element {
  const { icon: Icon, title } = interviewTypesInfo[type] || DEFAULT_INTERVIEW_TYPE_INFO;

  return (
    <Styles.Box onClick={() => onChoose(type)}>
      <Styles.Icon>
        <Icon />
      </Styles.Icon>

      <Styles.Title>{title}</Styles.Title>
    </Styles.Box>
  );
}
